let VideoTemplatesIndexTourSteps  = {
  tourSteps: function() {
    return [
        {
          content: 'The templates page lists the videos you have created.',
          target: '.help_icon_smaller',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: 'Use this button to create a new video. You can also create videos inline as you add or edit workflows.',
          target: '.new_template_btn',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: "This is the name of video. The people you are emailing don't see this.",
          target: '.template_name',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "The category for the video. You can create and assign a category to an video to group common videos together.",
          target: '.template_category',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "Click here to edit a video",
          target: '.template_edit',
          placement: 'top',
          disableBeacon: true
        }
    ];
  }
};
export default VideoTemplatesIndexTourSteps;
